import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { WalletContextProvider } from './providers/WalletProvider';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/Toast';
import { AlertsProvider } from './contexts/AlertsContext';
import { setupErrorTracking } from './lib/analytics';
import { initSentry } from './lib/sentry';
import App from './App';
import './styles/globals.css';

// Initialize error tracking
setupErrorTracking();
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <WalletContextProvider>
        <AuthProvider>
          <ToastProvider>
            <AlertsProvider>
              <App />
            </AlertsProvider>
            <Analytics />
          </ToastProvider>
        </AuthProvider>
      </WalletContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);
